<template>
  <PageLayout class="page">
    <template slot="header">
      <div class="d-flex m-3 mx-lg-0">
        <Breadcrumb :list="breadcrumb" />
      </div>
      <MainNavbar />
    </template>
    <template slot="main">
      <router-view />
    </template>
  </PageLayout>
</template>

<script>
import { mapGetters } from 'vuex'
import PageLayout from '@/components/Home/PageLayout.vue'
import Breadcrumb from '@/components/Shared/Breadcrumb.vue'
import MainNavbar from '@/components/Management/MainNavbar'

export default {
  components: { PageLayout, Breadcrumb, MainNavbar },
  data() {
    return {
      breadcrumb: [],
    }
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),

    labels: function() {
      return this.resources.page.home.accountDetail
    },
  },
  beforeMount() {
    this.$root.$on('set-breadcrumb', () => {
      this.breadcrumb = [{ label: this.resources.general.menu.settings }]
    })
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

header {
  h2 {
    color: map-get($theme-colors, 'septenary');
  }
}
</style>
